// src/components/SectionOne/SectionOne.js
import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import ReactECharts from "echarts-for-react";
import DeckGL from 'deck.gl';
import { Map } from 'react-map-gl';
import "./Contexto.css";
import { GeoJsonLayer } from '@deck.gl/layers';
import { env } from "echarts";
import { useEffect, useState } from "react";
import CollapsibleCitation from "../tools/CollapsibleCitation";
import InformationPopUp from "../tools/InformationPopUp";
export default function Contexto() {

  const makeRasterStyle = (urlTemplate, attribution = "") => ({
    version: 8,
    sources: {
      rastertiles: {
        type: "raster",
        tiles: [urlTemplate],
        tileSize: 256,
        attribution,
      },
    },
    layers: [
      {
        id: "rastertiles",
        type: "raster",
        source: "rastertiles",
      },
    ],
  });

    const BASEMAPS = {
    "Satellite": "https://raw.githubusercontent.com/go2garret/maps/main/src/assets/json/arcgis_hybrid.json",
    "Light Mode": makeRasterStyle(
      "https://basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors © CARTO'
    ),
    "Dark Mode": makeRasterStyle(
      "https://basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors © CARTO'
    ),
     "Streets": makeRasterStyle(
      "https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors © CARTO'
    ),
    "Open Street Map": makeRasterStyle(
      "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
      '© OpenStreetMap contributors'
    )
  };


  const mapContainerClass = "map-container";
  const [styleKey, setStyleKey] = useState("Satellite");
  const [populationData, setPopulationData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/data/csv/population.csv")
      .then((response) => response.text())
      .then((csvText) => {
        const lines = csvText.trim().split("\n");
        const data = lines.slice(1).map(line => {
          const [time_period, population] = line.split(",");
          return { time_period, population: parseFloat(population) };
        });
        setPopulationData(data);
        setLoading(false);
      });
  }, []);

  const chartOptions1 = {
   /*  title: {
      text: "Crecimiento Poblacional (2000 a 2020, número de personas)",
      top: 0,
    }, */
    grid: { left: '0%', containLabel: true, right: '15%' },
    tooltip: {},
    xAxis: {
      type: "category",
      data: populationData.map(d => d.time_period),
      name: 'Year',
    },
    yAxis: {
      type: "value",
      name: 'Population',
    },
    series: [{
      data: populationData.map(d => Number(d.population.toFixed(0))),
      type: "line"
    }],
  };

  const [builtAreaData, setBuiltAreaData] = useState([]);
  const [loadingBuiltArea, setLoadingBuiltArea] = useState(true);

  useEffect(() => {
    fetch("/data/csv/built_area.csv")
      .then((response) => response.text())
      .then((csvText) => {
        const lines = csvText.trim().split("\n");
        const data = lines.slice(1).map(line => {
          const [time_period, settlements] = line.split(",");
          return { time_period, settlements: parseFloat(settlements) };
        });
        setBuiltAreaData(data);
        setLoadingBuiltArea(false);
      });
  }, []);

  const chartOptions2 = {
    /* title: {
      text: "Superficie Urbanizada (2000 a 2020, km²)",
      top: 0,
    }, */
    tooltip: {},
    grid: { left: '5%', containLabel: true, right: '15%' },
    xAxis: {
      type: "category",
      data: builtAreaData.map(d => d.time_period),
      name: 'Year',
    },
    yAxis: {
      type: "value",
      name: 'Area (km²)'
    },
    series: [{
      data: builtAreaData.map(d => Number((d.settlements.toFixed(2)/100).toFixed(2))), // Convert m² to km²
      type: "line"
    }],
  };

  // Reference the entire section to detect when it’s in view
  const sectionRef = useRef(null);

  // useInView returns true when the element is sufficiently in the viewport
  const isInView = useInView(sectionRef, {
    amount: 0.5, // how much of the element should be in view to trigger
    once: false,  // whether it should only animate once
  });

    // GeoJsonLayer for DeckGL

    // Example GeoJSON data (replace with your own)
    

    const geoJsonLayer = new GeoJsonLayer({
      id: 'geojson-layer',
      data: "/data/geojson/georgetown.geojson", // Path to your GeoJSON file
      filled: true,
      getFillColor: [34, 139, 34, 77],
      getLineColor: [34, 139, 34, 255],
      lineWidthMinPixels: 1,
      stroked: true,
      pickable: false,
    });

    return (
      <motion.div
        ref={sectionRef}
        className="h-full w-full snap-start grid grid-cols-3 gap-6 bg-white"
        style={{ aspectRatio: "16/9" }}
        // We can animate this entire container
        initial={{ opacity: 0, y: 20 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1 }}
      >
        {/* Left Column - Text Content */}
        <div className="col-span-1 flex flex-col justify-center gap-2 px-4  overflow-y-auto mt-[-5dvh]">
          <motion.h1
            className="text-5xl font-bold text-[#324130] mt-10"
            // Each sub-element can have its own animation
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.2 }}
            >
            Georgetown 
            <InformationPopUp 
            title="Analysis Region"
            description="This map shows the analysis region used to generate all graphs and statistics. It is obtained from the boundaries of the metropolitan area, applying a 10 km buffer around them to include peripheral zones." 
            color="324130" 
            color_citation="#000"
            />
            
            </motion.h1>

            <motion.h2
            className="text-3xl text-[#92843B] mt-[-2]"
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.4 }}
            >
            Demerara-Mahaica
            
            </motion.h2>

            <motion.p
            className="text-justify text-xs leading-relaxed"
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.6 }}

            >
              <strong>Georgetown</strong>, the <strong>capital of Guyana</strong>, is a <strong>mid-sized city</strong> that concentrates a <strong>substantial portion of the national population</strong> and serves as the <strong>main hub for infrastructure, transportation, and services</strong> in the country. With <strong>118,369 inhabitants</strong> distributed over an <strong>urban area of 156 km²</strong>, it has a <strong>density of 759 inhabitants/km²</strong>, one of the highest among the cities analyzed. Its <strong>population growth rate</strong> is <strong>negative (-1.3% annually)</strong>, indicating a <strong>sustained reduction</strong> in the number of residents.
            <br /><br />
      The <strong>urban footprint</strong> covers a <strong>consolidated urban center of 79 km²</strong>, <strong>62 km² of suburban areas</strong>, and <strong>urban clusters of moderate density (10 km² dense and 5 km² semi-dense)</strong>. The <strong>expansion pattern</strong> is influenced by its <strong>coastal location</strong> and <strong>geographic surroundings</strong>, limited by the <strong>Atlantic Ocean</strong>, the <strong>Demerara River</strong>, and <strong>agricultural zones inland</strong>.
            <br /><br />
      Its <strong>exposure to heavy rainfall</strong>, <strong>low altitude</strong>, and <strong>pressure on hydraulic infrastructure</strong> creates a <strong>relevant environment</strong> for evaluating <strong>emissions associated with land use change</strong>, especially in <strong>peri-urban</strong> and <strong>coastal areas</strong>.
            <br /><br />
            
  <strong>Experimenting Paths</strong> is a <strong>strategic action</strong> of the <strong>Amazonian Cities Forum</strong> that seeks to support <strong>adaptation and mitigation of climate change</strong> in the <strong>Amazon region</strong>, through the <strong>testing of creative and viable solutions</strong> that can be <strong>effective, scalable, and replicable</strong>. The initiative is implemented by <strong>Geoadaptive</strong>, with the <strong>technical and financial support</strong> of the <strong>Inter-American Development Bank (IDB)</strong>, within the framework of the <strong>Amazonia Forever</strong> program. It also has the <strong>technical support</strong> of the <strong>Cities Lab</strong> of the IDB and the <strong>Tecnologico de Monterrey</strong>.
            </motion.p>
          </div>

          {/* Right Column - Map and Charts */}
        <div className="col-span-2 flex flex-col justify-center items-center gap-4 px-20">
          <motion.div
            className={`${mapContainerClass} relative w-full h-[40%] rounded-2xl shadow-lg mt-5 `}
            style={{ aspectRatio: "16/9" }}
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.8 }}
          >
          <div className="absolute left-3 top-3 z-10 text-black">
            <select
              value={styleKey}
              onChange={(e) => setStyleKey(e.target.value)}
              className="bg-white/90 backdrop-blur px-3 py-1.5 rounded-md text-sm shadow border border-black/10"
            >
              {Object.keys(BASEMAPS).map((k) => (
                <option key={k} value={k}>
                  {k}
                </option>
              ))}
            </select>
          </div>
              <DeckGL
                initialViewState={{
                  latitude: 6.763,
                  longitude: -58.055,
                  zoom: 10,
                  pitch: 0,
                  bearing: 0,
                }}
                controller={false}
                layers={[geoJsonLayer]}
              >
                <Map
                  mapStyle={BASEMAPS[styleKey]}
                  className="w-full"
                  attributionControl={false}
                />
              </DeckGL>
          </motion.div>

          <motion.div
            className="flex justify-between w-full gap-4"
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 1 }}
          >
            <div className="w-1/2" style={{ aspectRatio: "16/9" }}>
            <motion.h3
              className="text-xl font-semibold"
              initial={{ opacity: 0, y: -10 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Population Growth
              <InformationPopUp
                title="Crecimiento Poblacional"
                description="This chart shows the population growth in Georgetown from 2000 to 2020, with annual population data."
                color="324130"
                title_citation="Crecimiento Poblacional"
                source="GHS POP"
                fullCitation="Carioli, A., Schiavina, M., Freire, S., y MacManus, K. (2023). GHS-POP R2023A: GHS population grid multitemporal (1975–2030) [Conjunto de datos]. European Commission, Joint Research Centre (JRC). https://doi.org/10.2905/2FF68A52-5B5B-4A22-8F40-C41DA8332CFE"
                color_citation="000"
              />
            </motion.h3>
              <ReactECharts option={chartOptions1} className="w-full h-full mt-[0%]" />
              

            </div>
            <div className="w-1/2" style={{ aspectRatio: "16/9" }}>
            <motion.h3
              className="text-xl font-semibold"
              initial={{ opacity: 0, y: -10 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              Urbanized Area
              <InformationPopUp
                title="Urbanized Area"
                description="This chart shows the change in urbanized area by five-year periods, from 2000 to 2020. Urbanized area is defined as all land covered by artificial structures created by humans."
                color="324130"
                source="GHS BUILT"
                fullCitation="Pesaresi, M. y Politis, P. (2023). GHS-BUILT-S R2023A: GHS built-up surface grid, derived from Sentinel-2 composite and Landsat, multitemporal (1975–2030) [Conjunto de datos]. Comisión Europea, Centro Común de Investigación (JRC). https://doi.org/10.2905/9F06F36F-4B11-47EC-ABB0-4F8B7B1D72EA"
                color_citation="#000"
              />
            </motion.h3>
              <ReactECharts option={chartOptions2} className="w-full h-full mt-[0%]" />
              
              
            </div>
          </motion.div>
        </div>
      </motion.div>
    );
}
